import { createContext, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getAll as getAllProjects, create as createProject } from '../services/project/projectService';
import { useParams } from 'react-router-dom';

const ProjectContext = createContext();

export const useProjects = () => useContext(ProjectContext);

export const ProjectProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [isProjectReadOnly, setIsProjectReadOnly] = useState(false);
  const { projectId } = useParams();

  useEffect(() => {
    if (!projectId || !projects?.length) return;

    const proj = projects.find(p => p.id === Number(projectId));
    setIsProjectReadOnly(!!proj?.deletedAt);
  }, [projectId, projects]);
  const fetchProjects = async () => {
    try {
      const response = await getAllProjects();
      const projects = response.projects.map(item => ({
        ...item,
        path: `projects/${item.id}`
      }));
      setProjects(projects);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
      toast.error(error.response?.data?.errorMessage || 'Something went wrong');
    }
  };


  useEffect(() => {
    fetchProjects();
  }, []);

  const addProject = async (newProject) => {
    try {
      const { project } = await createProject(newProject);
      fetchProjects();
      return project;
    } catch (error) {
      console.error('Failed to fetch projects:', error);
      toast.error(error.response?.data?.errorMessage || 'Something went wrong');
    }
  };

  return (
    <ProjectContext.Provider value={{ projects, fetchProjects, addProject, isProjectReadOnly }}>
      {children}
    </ProjectContext.Provider>
  );
};
